import React from "react";
import { motion } from "framer-motion";
import "./TallyPrime.css";
import TallyShowcase from "./TallyShowcase";
// import TallyHome from "./TallyHome";
const TallyPrime = () => {
  return (
    <div className="tallyprime-container tally-prime-page">
      <div className="tally-hero-banner">
        <img src="/images/tally-cover.png" alt="TallyPrime Corporate Banner" className="hero-banner-img" />
        <div className="hero-banner-overlay">
         
        </div>
      </div>

      <div className="tally-inner">
        <TallyShowcase />

        {/* ── Section: Feature Excellence Grid ── */}
        <section className="tally-features-showcase">
          <div className="showcase-header">
            <span className="subtitle">Core Pillars</span>
            <h2>Why Choose TallyPrime?</h2>
          </div>

          <div className="tally-features-grid">
            {/* Card 1: Simplicity */}
            <motion.div 
              className="feature-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="card-image">
                <img src="/images/unnamed-1-removebg-preview.png" alt="Simplicity" />
              </div>
              <div className="card-content">
                <h3>Simple to Learn, Easier to Use</h3>
                <p>Set up in less than a minute and get immediate access to all the business features you need without a steep learning curve.</p>
              </div>
            </motion.div>

            {/* Card 2: Insights */}
            <motion.div 
              className="feature-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="card-image">
                <img src="/images/tally/Blog_Effortless-e-Invoicing-with-TallyPrimes-e-Tims-solution-2.jpg" alt="Insights" />
              </div>
              <div className="card-content">
                <h3>Insightful & Actionable Reports</h3>
                <p>Harness the power of readily available business reports with deep insights to make informed decisions for your growth.</p>
              </div>
            </motion.div>

            {/* Card 3: Security */}
            <motion.div 
              className="feature-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <div className="card-image">
                <img src="/images/tally/Tally-on-Cloud-Right-For-Your-Business-1.png" alt="Security" />
              </div>
              <div className="card-content">
                <h3>Anytime & Secure Access</h3>
                <p>Access crucial business data from anywhere, whenever you need it, ensuring industry-standard security at all times.</p>
              </div>
            </motion.div>
          </div>
        </section>
      </div>
    </div>
  );
};


export default TallyPrime;
